import { Dispatch } from "redux";
import URLConstants from "../constants/url.constants";
import * as services from "../services/services";
import iaqDevicesType from "../types/iaqDevices.type";

export const getIAQDevices = (currentPage: number,pageLimit: number,isAdmin: boolean) => {
  return (dispatch: Dispatch) => {
    dispatch(getIAQDevicesStart());
    let url = URLConstants.GetAirIndexIAQDevices +'?pageNo=' + currentPage + '&pageSize=' + pageLimit + "&IsAdmin=" + isAdmin;
    services.get(url)
      .then((response) => {
        dispatch(getIAQDevicesSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getIAQDevicesError(err));
      });
  };
};

const getIAQDevicesStart = () => {
  return {
    type: iaqDevicesType.GET_IAQ_DEVICES_START,
  };
};

const getIAQDevicesSuccess = (data: any) => {
  return {
    type: iaqDevicesType.GET_IAQ_DEVICES_SUCCESS,
    payload: data,
  };
};

const getIAQDevicesError = (data: any) => {
  return {
    type: iaqDevicesType.GET_IAQ_DEVICES_ERROR,
    payload: data,
  };
};

export const resetIAQDevicesState = () => {
  return (dispatch: Dispatch) => {
    dispatch(resetIAQDevicesDispatcher());
  };
};

const resetIAQDevicesDispatcher = () => {
	return {
		type: iaqDevicesType.RESET_IAQ_DEVICES
	};
};

export const getFilterIAQSensorsService = (data: any) => {
	return (dispatch: Dispatch) => {
		dispatch(getIAQDevicesStart());
		let url = URLConstants.GetFilterIAQSensors;
		services.post(url, data)
			.then(response => {
				dispatch(getIAQDevicesSuccess(response.data));
			})
			.catch(err => {
				dispatch(getIAQDevicesError(err));
			});
	};
};

const getIAQSensorFilterSuccess = (data: any) => {
	return {
		type: iaqDevicesType.GET_IAQ_SENSOR_FILTER_SUCCESS,
		payload: JSON.parse(data)
	};
};

export const getIAQSensorFilter = () => {
  return (dispatch: Dispatch) => {
    let sensorData = localStorage.getItem("IAQSensor.Filter");
    dispatch(getIAQSensorFilterSuccess((sensorData)));
  };
};

const resetIAQSensorFilterDispatcher = () => {
	return {
		type: iaqDevicesType.RESET_IAQ_SENSOR_FILTER_STATE
	};
};

export const resetIAQSensorFilterState = () => {
  return (dispatch: Dispatch) => {
    dispatch(resetIAQSensorFilterDispatcher());
  };
};

// export const getIAQLegendDetails = () => {
//   return (dispatch: Dispatch) => {
//     dispatch(getIAQLegendDetailsStart());
//     let url = URLConstants.GetLegendDetails;
//     services.get(url)
//       .then((response) => {
//         dispatch(getIAQLegendDetailsSuccess(sensorConfigJSONData));
//       })
//       .catch((err) => {
//         dispatch(getIAQLegendDetailsError(err));
//       });
//   };
// };

// const getIAQLegendDetailsStart = () => {
//   return {
//     type: iaqDevicesType.GET_IAQ_LEGENDS_DETAILS_START,
//   };
// };

// const getIAQLegendDetailsSuccess = (data: any) => {
//   return {
//     type: iaqDevicesType.GET_IAQ_LEGENDS_DETAILS_SUCCESS,
//     payload: data,
//   };
// };

// const getIAQLegendDetailsError = (data: any) => {
//   return {
//     type: iaqDevicesType.GET_IAQ_LEGENDS_DETAILS_ERROR,
//     payload: data,
//   };
// };

// export const resetIAQLegendDetailsState = () => {
//   return (dispatch: Dispatch) => {
//     dispatch(resetIAQLegendDetailsDispatcher());
//   };
// };

// const resetIAQLegendDetailsDispatcher = () => {
// 	return {
// 		type: iaqDevicesType.RESET_IAQ_LEGENDS_DETAILS
// 	};
// };